import _taggedTemplateLiteral from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3;

import styled from "styled-components";
import { colors } from "../../../shared/constants";
import { Chip } from "../Chip";
var ChipContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  ", "\n"])), function (t) {
  return t.isReverse ? "transform: scaleX(-1)" : null;
}),
    ChipWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  position: relative;\n"]))),
    ActiveChip = styled(Chip)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  position: absolute;\n  left: 0;\n"])), colors.teal3);
export { ChipContainer, ChipWrapper, ActiveChip };